import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { timer, interval } from 'rxjs';
import { UsersService } from 'src/app/services/users.service';
export interface TimeSpan {
  hours: number;
  minutes: number;
  seconds: number;
}
@Component({
  selector: 'app-viewer-assessment',
  templateUrl: './viewer-assessment.component.html',
  styleUrls: ['./viewer-assessment.component.scss'],
  providers: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewerAssessmentComponent implements OnInit {
  countDown:any=''; counter:any=0;
  tick = 1000;
  currentStep:any='';isLastSubmodule:number=0;modulesId:any='';courseStatus:Number=1;EvaluationResults:any=[];
  assessmentType:any;spentTime:any;isPassed:Number=3;EvaluationResult:any=[];EvaluationResultFail:any=[];
  stepper:any;assessmentAttemt:any; totleTime:any;hours: any = 0; minutes: any = 0; seconds: any = 0;
  ModulSubData:any=[];moduleName:any='';moduleStatus:Number=0;
  userLoginData:any=[];assId:any='';assQuestinData:any=[];courseId:any='';moduleId:any='';submoduleId:any='';
  selectOption:any='';selectAnswer:any='';proPercent:any;proPerc:any;total_time_spent:any=1;total_question:any;
  responseData: any = [];request_status:number=1;
  private detailArray: any[] = [];currentData: any = ''; currentBaseUrl: any = '';
  selectedAnswer: any[] = []; myDate = new Date();
  selectedAnswers: any = [];CourseData: any = [];
  constructor(private changeDetector: ChangeDetectorRef,private _formBuilder: FormBuilder,private router: Router,private authUser: UsersService,private route: ActivatedRoute,private spinner: NgxSpinnerService,private datePipe: DatePipe,
    private modalService: NgbModal) { 
      this.currentData = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
    if (localStorage.getItem('userLoginData') =='' || localStorage.getItem('userLoginData') == null) {
      this.router.navigateByUrl('/');
    }
  }
  entries = new Date(new Date().getTime());
  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false  });
  }
  openSucessModel(content: any){
    this.modalService.open(content, { centered: true, size: 'md', backdrop: 'static', keyboard: false });
  }
  openFailModel(content: any){
    this.modalService.open(content, { centered: true, size: 'md', backdrop: 'static', keyboard: false });
  }
  openSentModel(content: any){
    this.contactAdministratorForAss(this.userLoginData.user_id,this.assId, this.request_status)
    
    this.modalService.open(content, { centered: true, size: 'md', backdrop: 'static', keyboard: false });
  }
  ngOnInit(): void {
    localStorage.removeItem('EvaluationResultFail');
    localStorage.removeItem('EvaluationResult');
    this.moduleName = JSON.parse(localStorage.getItem('moduleName') || '[]');
    //this.totalTimeSpentView = JSON.parse(localStorage.getItem('totalTimeSpent') || '[]');
    localStorage.setItem('AssessmentTimerStatus', JSON.stringify((1)));
    this.getAssessmentTimer();
    
    /******prevent Angular page refresh start */
    window.addEventListener("keyup", disableF5);
     window.addEventListener("keydown", disableF5);
    function disableF5(e:any) {
       if ((e.which || e.keyCode) == 116) e.preventDefault(); 
    };
    /****** End */
    this.countDown = timer(0, this.tick).subscribe(() => --this.counter);
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
    this.assId = queryParams['assId']; 
    this.assessmentType = queryParams['AT'];
    });
    if(this.assId !='' || this.assId !=null){
       this.assessmentDetail(this.assId);
       this.getAssessmentTimer();
      }
    interval(1000).subscribe(() => {
      this.changeDetector.detectChanges();
    });
      this.checkCoursesStatus(this.userLoginData.user_id,this.assId,2);
  }
  ngOnDestroy(){ this.countDown=null; }
  assessmentDetail(assId:any){
    this.authUser.assessmentData(assId,this.userLoginData.user_id,this.courseId).subscribe(
      data=>{
        if(data.status == 401){
          document.getElementById('successMsg')?.click();
          this.spinner.hide();
        }else{
          this.assQuestinData = data.data;
          this.counter = this.assQuestinData.assest_time_hr*60*60+this.assQuestinData.assest_time_min*60;
          setTimeout(() => {
            this.currentStep = this.assQuestinData.question_attempt; 
           // this.currentStep = 1; 
            }, 1000);
          this.proPerc = (100/this.assQuestinData.questions.length)*(this.currentStep+1);
        }
       // console.log(data);
       
      },error=>{
        //console.log(error);
      }
    )
  }
  assessmentPreQuestDetail(assId:any){
    this.authUser.assessmentPreData(assId,this.userLoginData.user_id,this.courseId).subscribe(
      data=>{
        // if(data.status == 401){
        //   document.getElementById('successMsg')?.click();
        //   this.spinner.hide();
        // }else{
        //   this.assQuestinData = data.data;
        //   this.counter = this.assQuestinData.assest_time_hr*60*60+this.assQuestinData.assest_time_min*60;
        //   setTimeout(() => {
        //     this.currentStep = this.assQuestinData.question_attempt; 
        //     }, 1000);
        //   this.proPerc = (100/this.assQuestinData.questions.length)*(this.currentStep+1);
        // }
       // console.log(data.data);
       
      },error=>{
       // console.log(error);
      }
    )
  }
  getAssessmentTimer(){
    this.authUser.assessmentUpdateTime(this.userLoginData.user_id,this.assId).subscribe(
      data=>{
        //console.log(data.time_difference);
        this.counter = (this.assQuestinData.assest_time_hr*60*60 + this.assQuestinData.assest_time_min*60) - data.time_difference ;
      },error=>{
        //console.log(error);
      }
    )
  }
/*****get answer *****/
  putAns(option:any,selectAnswer:any,type:any){
    this.selectOption = option;
    if(type==3){
      this.responseData=selectAnswer;
    }else{
      this.selectAnswer = selectAnswer;
    }
    
  }

  /*******assessment Answer submit */
  submitQueAns(assessment_id:any,question_num:any,assessment_question_id:any,index:any){
    this.spinner.show();
    this.proPerc = (100/this.assQuestinData.questions.length)*(index+1) ;
    this.authUser.assessmentSeprateSubmit(this.userLoginData.user_id,this.courseId,this.moduleId,this.submoduleId,assessment_id,
      question_num,assessment_question_id,this.selectAnswer,this.selectOption,this.responseData).subscribe(
      data=>{
        if(data.status == 401){
          document.getElementById('successMsg')?.click();
          this.spinner.hide();
        }else{
          this.selectOption = ''; this.selectAnswer = '';
        this.spinner.hide();
        }
       
      },error=>{
        this.spinner.hide();
      }
    )
  }
  getElapsedTime(){
    this.hours = Math.floor(this.counter / 3600);
    this.minutes = Math.floor((this.counter % 3600) / 60);
    this.seconds = (Math.floor(this.counter - ((this.hours*3600) + this.minutes * 60)));
    if(this.counter < 0){
      this.assessmentsEvaluation(this.assId,'','','');
    }
   // console.log(this.hours,'-',this.minutes,'-', this.seconds)
    return { hours: this.hours, minutes: this.minutes, seconds: this.seconds  };
  }
  assessmentsEvaluation(assessment_id:any,question_num:any,assessment_question_id:any,index:any){
    this.spinner.show();
     this.assessmentAttemt = this.assQuestinData.attempt_num+1;
     if(this.assessmentType == 0){
      this.total_time_spent = Math.floor((((this.assQuestinData.assest_time_hr*60*60 + this.assQuestinData.assest_time_min*60)-this.counter)% 3600) / 60);
      if(this.total_time_spent < 1){ this.total_time_spent = 1; }
      this.authUser.assessmentsSubmit(this.userLoginData.user_id,assessment_id,
        question_num,assessment_question_id,this.selectAnswer,this.selectOption,
        this.total_time_spent,this.assQuestinData.questions.length,this.assessmentAttemt,
        this.assessmentType,this.responseData).subscribe(
        data=>{
          this.spinner.hide();
          console.log(data,'submodule');
           if(data.data.is_passed == 1){
            //alert('You have passed the assessments')
            this.EvaluationResults = data.data;
            this.router.navigate(['/module_Passed'], { queryParams: {assId:this.assId,isPassed:data.is_passed, type:'ass'} });
          // this.getModuleDetails(this.moduleId,this.submoduleId,data.data.is_passed,data.data.courseStatus);
           }else{
             localStorage.setItem('EvaluationResultFail', JSON.stringify(data.data));
             this.router.navigate(['/module_failed'], { queryParams: {assId:this.assId,isPassed:data.is_passed, type:'ass'} });
            //  this.router.navigate(['/module_failed'], { queryParams: {assId:this.assId,isPassed:data.data.is_passed,modId:this.moduleId,subModlId:this.submoduleId,courseId:this.courseId,AT:this.assessmentType} });
          this.spinner.hide();
           }
        },error=>{
          this.spinner.hide();
        }
      )
     }else{
      this.total_time_spent = Math.floor((((this.assQuestinData.assest_time_hr*60*60 + this.assQuestinData.assest_time_min*60)-this.counter)% 3600) / 60);
      if(this.total_time_spent < 1){ this.total_time_spent = 1; }
      this.authUser.assessmentsSubmit(this.userLoginData.user_id,assessment_id,
        question_num,assessment_question_id,this.selectAnswer,this.selectOption,
        this.total_time_spent,this.assQuestinData.questions.length,this.assessmentAttemt,
        this.assessmentType,this.responseData).subscribe(
        data=>{
         // console.log(data,"module");
           if(data.data.is_passed == 1){
             this.EvaluationResults = data.data;
             alert('passed')
            //  this.getModuleDetails(this.moduleId,this.submoduleId,data.data.is_passed,data.data.courseStatus);
           }else{
              localStorage.setItem('EvaluationResultFail', JSON.stringify(data.data));
            //  this.router.navigate(['/module_failed'], { queryParams: {assId:this.assId,isPassed:data.data.is_passed,modId:this.moduleId,subModlId:this.submoduleId,courseId:this.courseId,AT:this.assessmentType} });
           }
        },error=>{
          this.spinner.hide();
        }
      )
     } 
  }

  goViewer(modId:any,subModlId:any,courseId:any){
    this.authUser.subModuleStartView(this.userLoginData.user_id,courseId,modId,subModlId).subscribe(
      data=>{
        this.router.navigate(['/viewer'], { queryParams: {modId:modId,subModlId:subModlId,courseId:courseId} });
      },error=>{
      }
    )
  }
  navigationEvent() {
    localStorage.removeItem('userLoginData');
    this.router.navigateByUrl('/'); 
    
    }
   
    /****incase admin make course deactive than check and redirect to assign list */
    checkCoursesStatus(user_id:number,assId:any,staus:any){
      this.spinner.show();
      this.authUser.checkAssmntStatus(user_id,assId,staus).subscribe(
        data=>{
        if(data.exits == 0){
          this.router.navigateByUrl('/assigned'); 
        }
        this.spinner.hide();
        },error=>{
          this.spinner.hide();
        }
      )
    }

    /*********use for match the following question match ********/
    drop(event: CdkDragDrop<string[]>,index:any,selectAnswer:any) {
      this.selectOption = index+1;
      this.responseData=selectAnswer;
      const from = event.previousIndex;
      const to = event.currentIndex;
      //const fromValue = this.assQuestinData.questions[index].responses[from].response_match;
     // const toValue = this.assQuestinData.questions[index].responses[to].response_match;
      const fromValue = this.assQuestinData.questions[index].match_responses[from].response_match;
      const toValue = this.assQuestinData.questions[index].match_responses[to].response_match;
      //console.log(this.selectOption,from,to);
      //console.log(this.selectOption,fromValue,toValue);
     // this.assQuestinData.questions[index].responses[from].response_match = toValue;
     // this.assQuestinData.questions[index].responses[to].response_match = fromValue;
      this.assQuestinData.questions[index].match_responses[from].response_match = toValue;
      this.assQuestinData.questions[index].match_responses[to].response_match = fromValue;
      
    }

    updateOrPushDetail(inputData: any) {
      const existingDetailIndex = this.detailArray.findIndex((detail) => detail.question_id === inputData.question_id);
  
      if (existingDetailIndex !== -1) {
        // Update the existing object if the question ID exists
        this.detailArray[existingDetailIndex] = inputData;
      } else {
        // Push a new object if the question ID doesn't exist
        this.detailArray.push(inputData);
      }
      return this.detailArray;
    }
    getDetails(QustId: number) {
      console.log(this.detailArray)
      const questionIdToMatch = QustId;
      for (const detail of this.detailArray) {
        if (detail.question_id === questionIdToMatch) {
          // Push response_id and response_text to the selectedAnswers array
          this.selectedAnswer.push({
            response_id: detail.response_id,
            response_text: detail.response_text,
          });
        }
      }
    }
    showSelectedAnswer(questionIndex: number) {
      const selectedAnswer = this.selectedAnswers[questionIndex];
      this.selectAnswer = selectedAnswer;
      console.log(`Question ${questionIndex + 1} - Selected Answer: ${selectedAnswer}`);
      // You can update the UI to display the selected answer if needed.
    }
    submitAnswers() {
      const submittedAnswers = [];
      this.total_time_spent = Math.floor((((this.assQuestinData.assest_time_hr * 60 * 60 + this.assQuestinData.assest_time_min * 60) - this.counter) % 3600) / 60);
      if (this.total_time_spent < 1) { this.total_time_spent = 1; }
  
      for (let i = 0; i < this.assQuestinData.questions.length; i++) {
        const question = this.assQuestinData.questions[i];
        const selectedAnswer = this.selectedAnswers[i];
        const selectedAnswerIndex = question.responses.findIndex((response:any) => response.response === selectedAnswer);
        const dragDropAnswers =  this.responseData;
        console.log(dragDropAnswers)
  
        if (selectedAnswerIndex !== -1) {
          submittedAnswers.push({
            question_num:question.question_num,
            question_text: question.question_text,
            question_id: question.assessment_question_id,
            selected_answer: selectedAnswer,
            response_id: selectedAnswerIndex+1
          });
        } else if (dragDropAnswers.length > 0) {
          submittedAnswers.push({
            question_num:question.question_num,
            question_id: question.assessment_question_id,
            question_text: question.question_text,
            selected_answer: dragDropAnswers,
          });
        } else {
          // Handle unanswered questions
          submittedAnswers.push({
            question_num:question.question_num,
            question_id: question.assessment_question_id,
            question_text: question.question_text,
            response_id:selectedAnswerIndex+1,
            selected_answer: 'No answer selected',
          });
        }
      }
      console.log('QuestionData:', submittedAnswers);
      console.log(this.assQuestinData.attempt_num,'this.assQuestinData.attempt_num')
      const postJson = {
        "user_id": this.userLoginData.user_id,
       // "course_id": this.courseId,
      //  "module_id": this.moduleId,
        "assessment_id": this.assId,
       "attempt_num": this.assQuestinData.attempt_num + 1,
       // "attempt_num": 1,
        "question_data": submittedAnswers,
        "total_time_spent":this.total_time_spent,
        "total_question":this.assQuestinData.questions.length,
        "assessment_type":this.assessmentType
  
      };
      console.log('FinalSubmit:', postJson);
      this.authUser.assesmentSubmit(postJson).subscribe(
        data => {
          this.EvaluationResults = data.data;
      //     console.log(this.userLoginData?.user_type,'this.userLoginData?.user_type');
      // console.log(this.assQuestinData?.internal_org_pass_no_of_questions,'this.assQuestinData?.internal_org_pass_no_of_questions');
      //     console.log(data?.data?.totalcorrectQsn,'data?.data?.totalcorrectQsn');
      //     if (this.userLoginData?.user_type == 1 && this.assQuestinData?.internal_org_pass_no_of_questions <= data?.data?.totalcorrectQsn){
      //       localStorage.setItem('EvaluationResult', JSON.stringify(this.EvaluationResults));
      //       document.getElementById('successPopup')?.click();

      //     }else if(this.userLoginData?.user_type == 2 && this.assQuestinData?.external_org_pass_no_of_questions <= data?.data?.totalcorrectQsn){
      //       localStorage.setItem('EvaluationResult', JSON.stringify(this.EvaluationResults));
      //       document.getElementById('successPopup')?.click();

          
          if (data?.data?.is_passed == 1) {
            localStorage.setItem('EvaluationResult', JSON.stringify(this.EvaluationResults));
            document.getElementById('successPopup')?.click();
           } else {
            localStorage.setItem('EvaluationResultFail', JSON.stringify(data.data));
            this.spinner.hide()
            document.getElementById('failPopup')?.click();
            }
          }, error => {
            this.spinner.hide();
          }
        )
    }
    closeModelPopup(){
      this.modalService.dismissAll();
      this.router.navigateByUrl('/assessments');
    }
    contactAdministratorForAss(user_id:number,assessment_id:any, request_status:any){
      this.spinner.show();
      this.authUser.contactAdministratorForAss(user_id,assessment_id, request_status).subscribe(
        data=>{
          if(data.status == 401){
              document.getElementById('successMsg')?.click();
              this.spinner.hide();
          }else{
          this.spinner.hide();
          }
        
        },error=>{
          this.spinner.hide();
        }
      )
    }
    


}